import {Navigate} from 'react-router'

import {HProduceSuiteLayout} from '../Components/Base/HProduceSuiteLayout'
import {RouterRootErrorBoundary} from '../Components/errorBoundaries/RouterRootErrorBoundary'

import {FeatureRoutes} from './features/FeatureRoutes'
import {FeatureNameGuard} from './features-menu/FeatureNameGuard'
import {FeaturePlantAvailabilityGuard} from './features-menu/FeaturePlantAvailabilityGuard'
import {FeatureScopeGuard} from './features-menu/FeatureScopeGuard'
import {HierarchyIdGuard} from './HierarchyIdGuard'
import {HierarchyIdRedirect} from './HierarchyIdRedirect'
import {HomePageGuard} from './HomePageGuard'
import {LoginGuard} from './LoginGuard'
import {NotFoundPage} from './NotFoundPage'
import {ROUTES} from './routing/routes'
import {UpmPlantsGuard} from './UpmPlantsGuard'
import {WelcomeFlow} from './WelcomeFlow'

export const AppRoutes = [
  {
    element: <HProduceSuiteLayout />,
    errorElement: <RouterRootErrorBoundary />,
    children: [
      {
        element: <LoginGuard />,
        children: [
          {
            path: ROUTES.path,
            element: <WelcomeFlow />,
            children: [
              {
                index: true,
                element: <HomePageGuard />
              },
              {
                path: ROUTES.FEATURE.path,
                element: <FeatureNameGuard />,
                children: [
                  {
                    index: true,
                    element: <HierarchyIdRedirect />
                  },
                  {
                    path: ROUTES.FEATURE.HIERARCHY_ID.path,
                    element: <HierarchyIdGuard />,
                    children: [
                      {
                        element: <FeatureScopeGuard />,
                        children: [
                          {
                            element: <FeaturePlantAvailabilityGuard />,
                            children: [
                              {
                                element: <UpmPlantsGuard />,
                                children: [
                                  {
                                    index: true,
                                    element: <FeatureRoutes />
                                  },
                                  {
                                    path: '*',
                                    element: <FeatureRoutes />
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                path: '*',
                element: <Navigate to={ROUTES.NOT_FOUND.path} replace />
              }
            ]
          }
        ]
      },
      {
        path: ROUTES.NOT_FOUND.path,
        element: <NotFoundPage />
      }
    ]
  }
]
